import {ArchiveFileEntry} from "../ArchiveViewer";
import styled from "styled-components";
import moment from "moment/moment";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClockRotateLeft, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import {faFileCode} from "@fortawesome/free-regular-svg-icons";
import {apiFetch, confirmAction} from "../../util";
import {toast} from "react-toastify";


type PropsI = {
    entry: ArchiveFileEntry,
    projectName: string
    backend: string
    entryType: string,
    entryKey: string,
    createCopy: boolean,
    removeEntry: (arg0: string) => void
};
export default function FileEntry({entry, projectName, backend, entryKey, entryType, createCopy, removeEntry}: PropsI) {

    const query = `project=${projectName}&type=${entryType}&entryKey=${entryKey}&entryName=${entry.name}`;
    const url = `${backend}/astra/viewRawArchiveEntry.php?${query}`

    const deleteEntry = async () => await confirmAction({
        message: entry.name + " - Видалити цю схему?",
        onConfirm: async () => {
            const {success} = await apiFetch(`${backend}/astra/deleteArchiveEntry.php?${query}`, {method: "DELETE"});
            if (success) {
                toast.success("Схему видалено");
                removeEntry(entry.name)
            }
        }
    });

    const restoreEntry = async () => await confirmAction({
        message: entry.name + " - Відновити цю схему?",
        onConfirm: async () => {
            const {success} = await apiFetch(`${backend}/astra/restoreArchiveEntry.php?${query}&createCopy=${createCopy}`);
            if (success) window.location.reload()
        }
    });

    return <Container>
        <a href={url} target={"_blank"}
           rel="noreferrer">
            <FontAwesomeIcon icon={faFileCode} className={'fa-color'} size={"lg"}/>
            <span className={'file-name-time'}>{moment(entry.mtime * 1000).format("DD MMMM YYYY HH:mm:ss")}</span>
        </a>
        <button className={'btn-cmn restore'} onClick={restoreEntry}>
            <FontAwesomeIcon icon={faClockRotateLeft} className={'fa-color-text'} size={"lg"}/>
        </button>
        <button className={'btn-cmn'} onClick={deleteEntry}>
            <FontAwesomeIcon icon={faTrashCan} className={'fa-color-text'} size={"lg"}/>
        </button>
    </Container>
}

const Container = styled.div`
    display: flex;
    gap: .5rem;
    flex-wrap: wrap;

    align-items: center;

    & .restore {
        margin-left: auto;
    }

    & a {
        display: flex;
        gap: .5rem;

        color: var(--table-action-color);

        &:visited {
            color: lightpink;
        }
    }

    & .file-name-time {
        font-family: monospace;
        font-size: 1rem;
        background: var(--table-row-even-bg-color);
        padding: .1rem .2rem;
        border-radius: .2rem;
    }

`
